module.exports = __webpack_public_path__ + "assets/img/modal-avatar-a4f52c37.png";